// The problem was converting the array's coming value format into its regular format.
// example it take mock.path.0 into mock.path[0]

export function check(select) {
  select.namespace.shift();
  let partialPath = select.namespace.map(path => {
    if (!isNaN(path)) {
      return `[${path}]`;
    }
    return path;
  });
  let fullPath = partialPath.join('.').replaceAll('.[', '[');
  return copyClipboard(`{{ ${fullPath} }}`);
}

export function valueCopy(value) {
  return copyClipboard(value);
}

function copyClipboard(value) {
  return navigator.clipboard.writeText(value);
}
